import useSWR from "swr";
import UserPermissionsService from "services/UserPermissionsService";
import MenuService from "services/MenuService";
import { getUser } from "helpers";
import dashRoutes from "routes";

// Lista de paths a excluir
const excludedPaths = [
    "/new-message",
    "/customers",
    "/customer-quotes",
    "/reports/report",
    "/reports/sales-report",
    "/store-manager",
    "/google-shopping-feed",
    "/markerplace-exporter",
    "/rma",
    "/activity-log",
    "/popular-models",
    "/bulk-items-configuration",
    "/edit-item",
    "/image-library",
    "/home-page-specials",
    "/message-template",
    "/pick-up-options",
    "/manage-related-items",
    "/message-center",
    "/part-number-url",
    "/about-us",
];

const flattenRoutes = (routes) => {
    return routes.reduce((acc, route) => {
        if (Array.isArray(route.views)) {
            acc.push(...flattenRoutes(route.views));
        } else {
            acc.push(route);
        }
        return acc;
    }, []);
};

const fetcher = async (id) => {
    if (!id) return null;

    const [permissionsResponse, fullMenu] = await Promise.all([
        UserPermissionsService.getMenuOptionsByUserId(id),
        MenuService.getAll(),
    ]);

    const menuOptions = permissionsResponse.menuOptions || [];

    const filteredMenu = fullMenu.filter((item) =>
        menuOptions.map(Number).includes(Number(item.id))
    );

    const filteredChildren = filteredMenu.filter((item) => item.parentMenuId !== 0);
    const allowedPaths = filteredChildren.map((item) => item.path);

    const flatRoutes = flattenRoutes(dashRoutes);

    const permittedRoutes = flatRoutes
        .filter((route) => allowedPaths.includes(route.path) && !excludedPaths.includes(route.path))
        .sort((a, b) => a.name.localeCompare(b.name));

    return {
        menuOptions,
        fullMenu,
        filteredMenu,
        permittedRoutes,
    };
};

const useUserPermissions = () => {
    const user = getUser();
    const userId = user?.id;

    const { data, error, isLoading, mutate } = useSWR(
        userId ? `/user-permissions-complete/${userId}` : null,
        () => fetcher(userId)
    );

    return {
        menuOptions: data?.menuOptions || [],
        fullMenu: data?.fullMenu || [],
        filteredMenu: data?.filteredMenu || [],
        permittedRoutes: data?.permittedRoutes || [],
        isLoading,
        isError: !!error,
        mutate,
    };
};

export default useUserPermissions;
